import { NotifyHelper } from "../../../helpers/toast";
import { eKyHieuHoaDonActionsObj } from "../../action-types/hoa-don/IKyHieuHoaDonAction";
import { generateActionForKey, generateActions } from "../generateActions";

export const kyHieuHoaDonActions = {
  ...generateActions(eKyHieuHoaDonActionsObj, "KY_HIEU_HOA_DON"),
  ...generateActionForKey(
    eKyHieuHoaDonActionsObj,
    "KY_HIEU_HOA_DON",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eKyHieuHoaDonActionsObj,
    "KY_HIEU_HOA_DON",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eKyHieuHoaDonActionsObj,
    "KY_HIEU_HOA_DON",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eKyHieuHoaDonActionsObj,
    "KY_HIEU_HOA_DON",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
